module.exports = __webpack_public_path__ + "static/media/rightimg.c6c537c1.png";